export default class StringUtil 
{
    public static isNullOrWhiteSpace(value : string) : boolean
    {
        return value === null || (/^\s*$/).test(value);
    }

    public static csvEscapeString(value : string) : string
    {
        return `"${value.replace(/"/g, '""')}"`;
    }

}

export function compareNamesRegardlessOfSpaces(a : string, b : string)
{
    const aMutated = a.trim().split(' ').filter(a=>a != '').join(' ');
    const bMutated = b.trim().split(' ').filter(a=>a != '').join(' ');
    return aMutated === bMutated;
}